<script>
import axios from "axios";
import { Pie, mixins } from "vue-chartjs";
import { getRandomColor } from "../../src/base";

export default {
  extends: Pie,
  mixins: [mixins.reactiveData],
  data() {
    return {
      chartData: "",
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  async created() {
    await axios
      .get("https://scathachbot.xyz/api/userblocked")
      .then((response) => {
        this.chartData = response.data;
      })
      .catch((error) => {
        console.log(error);
        alert("Error: " + error);
      });

    const user = this.chartData;

    this.chartData = {
      //get all keys from user object
      //labels: Object.keys(user),
      labels: ["Blocked Users", "Blocked Guilds"],
      datasets: [
        {
          backgroundColor: [getRandomColor(), getRandomColor()],
          data: [user.block_user, user.block_server]
        }
      ]
    };
  }
};
</script>